<template>
  <div class="w-full">
    <div class="flex cursor-pointer" @click="handleReadMore">
      <div class="w-1/4 mx-auto">
        <img
          :src="image"
          alt="Blogs"
          class="h-20 w-20 rounded-md mx-auto object-contain"
        />
      </div>
      <div class="w-3/4 my-auto pl-4">
        <p class="mc-title text-black font-bold ellipsis-2">
          {{ title }}
        </p>
        <!-- <p class="fsize18px clr777">5 minute read</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import blogMixin from "../mixins/blogMixin";

export default {
  mixins: [blogMixin],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    image() {
      return `${this.$imageURL}/${this.item.image}`;
    },
    title() {
      return this.item.title;
    },
    category() {
      // console.log(this.item);
      return this.$route.params.category;
    },
  },
};
</script>
